import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import ParticleBoard from './ParticleBoard';

export default class CloudParticle extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {ParticleBoard} parentRef
   * @param {integer} x
   * @param {number} y
   * @param {string} frame
   * @param {string} texture
   */
  constructor(scene, parentRef, x = 0, y = 0, frame = 'Particle_1', texture = ABCyaPhaser.Images.DEFAULT_ATLAS) {
    super(scene, x, y, texture, frame);

    this.parentRef = parentRef;
    this.speed = null;
    this.x = -140;
    this.y = null;
    this.destX = null;
    this.alpha = 1;
    this.scaleX = 1;
    this.scaleY = 1;
    this.visible = false;

    this.parentRef.add(this);
  }

  reset(spritename, speed, startY, endX, a, scale) {
    this.speed = speed;
    this.x = -140;
    this.y = startY;
    this.destX = endX;
    this.alpha = a;
    this.scaleX = scale;
    this.scaleY = scale;
    this.visible = true;
    this.setFrame(spritename);
  };

  tick(d) {
    this.x += this.speed * d / 1000;
    if (this.x > this.destX) {
      this.parentRef.resetParticle(this);
    }
  };
}